module.exports = __webpack_public_path__ + "img/62.cf646192.png";